'use client';

import { useModal } from '@ebay/nice-modal-react';
import { match } from 'ts-pattern';
import { useExpectedOnetimePlanPrice, usePlanStatusType } from '../hooks';
import { TossWidgetModal } from '../modals';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../types';
import { getVatPreview } from '../utils';
import { SharedPlanPaymentButton } from './shared';
export const PlanPaymentOnetimeSubmit = () => {
  const {
    selectedPlanInfo,
    isUpdate,
    isKrPayment,
    planPaymentInfo,
    currencyString,
    currentSpacePlanHashId,
    spaceHashId,
    userCountryCode
  } = usePlanPaymentInfoContext();
  const {
    watch,
    getValues,
    handleSubmit
  } = usePlanPaymentFormContext();
  const planType = watch('planType');
  const maxCcu = watch('maxCcu');
  const isCustomOnetimePeriod = watch('isCustomOnetimePeriod');
  const planTemplateType = watch('planTemplateType');
  const onetimePeriod = watch('onetimePeriod');
  const planStatusType = usePlanStatusType({
    planType
  });
  const tossWidget = useModal(TossWidgetModal);
  const {
    추가결제예상금액
  } = useExpectedOnetimePlanPrice({
    selectedPlanInfo,
    enabled: isUpdate && planTemplateType === PlanTemplateType.PRODUCT_ONETIME,
    spacePlanHashId: planPaymentInfo?.spacePlan?.spacePlanHashId ?? ''
  });
  const buttonPrice = match([isUpdate, planStatusType]).with([true, 'UP_GRADE'], () => 추가결제예상금액 < 0 ? 0 : 추가결제예상금액)
  // 신규 일시납은 판매 템플릿의 서버 priceInfo를 우선 사용한다.
  // 실제 Toss 결제 amount는 order-info의 서버 priceInfo.finalPrice로 한 번 더
  // 동기화된다 (Gate D).
  .otherwise(() => selectedPlanInfo.priceInfo?.finalPrice ?? getVatPreview({
    amount: selectedPlanInfo.salePrice,
    currency: isKrPayment ? 'KRW' : 'USD',
    userCountryCode,
    scenario: 'PRODUCT_ONE_TIME_PAYMENT'
  }).finalPrice);
  const isButtonDisabled = planType === 'enterprise' || isUpdate && planStatusType === 'SAME_GRADE' || isUpdate && planStatusType === 'DOWN_GRADE' || onetimePeriod === undefined || maxCcu >= 300 && planTemplateType === PlanTemplateType.PRODUCT_ONETIME && isCustomOnetimePeriod;
  const onSubmit = () => {
    const formData = getValues();
    void tossWidget.show({
      price: buttonPrice,
      onetimeStartDate: formData.onetimeStartDate,
      selectedPlanInfo,
      isUpdate,
      spacePlanHashId: currentSpacePlanHashId,
      spaceHashId,
      spaceId: planPaymentInfo?.spaceId
    });
  };
  const onError = () => {
    // FIXME: Input의 화면 상단에 있는 경우에 깨지는 코드이므로 그때는 고쳐야 함
    // input 오류 발생 시 에러 메시지를 확인할 수 있도록 스크롤을 최하단으로 이동
    // 문제가 발생하는 input으로 focus하는 방식으로 개선해야 함(비용이 커서 나중으로 미룸)
    window.scrollTo(0, document.body.scrollHeight);
  };
  return <SharedPlanPaymentButton isButtonDisabled={isButtonDisabled} buttonPrice={buttonPrice} currencyString={currencyString} onClick={handleSubmit(onSubmit, onError)} data-sentry-element="SharedPlanPaymentButton" data-sentry-component="PlanPaymentOnetimeSubmit" data-sentry-source-file="PlanPaymentOnetimeSubmit.tsx" />;
};